const formatter = new Intl.NumberFormat('de-DE', {
  style: 'currency',
  currency: 'EUR',
  minimumFractionDigits: 2,
});

export function formatCurrency(amount: number): string {
  if (isNaN(amount)) return 'Auf Anfrage';
  if (amount === 0) return 'Kostenlos';
  return formatter.format(amount);
}

export function formatPrice(amount: number, locale = 'de-DE', currency = 'EUR'): string {
  return new Intl.NumberFormat(locale, {
    style: 'currency',
    currency: currency,
  }).format(amount);
}
